exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".scroll-overflow{overflow-y:scroll;height:400px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/pages/ConfirmAccountRecoveryPage/styles.scss
// module id = 942
// module chunks = 0